<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div
        class="modal-import"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
      >
        <header class="modal-header" id="modalTitle">
          <slot name="header">
            Импорт пользователей
            <button
              type="button"
              class="btn btn-link"
              @click="loadImportUsersTemplate()"
            >
              Скачать шаблон
            </button>

            <button
              type="button"
              class="btn-close"
              @click="close"
              aria-label="Close modal"
            >
              x
            </button>
          </slot>
        </header>
        <div id="app" style="padding: 10px">
          <div
            style="
              color: #721c24;
              background-color: #f8d7da;
              padding: 10px;
              border-radius: 5px;
              margin-bottom: 15px;
            "
          >
            <strong>Важно:</strong> Файл должен содержать следующие колонки в
            первой строке: <br />username, password, role, photo
            <br />Допустимые значения для роли: teacher, employee,
            parent_comitet, parent, admin
          </div>

          <label>
            <input
              type="file"
              id="files"
              ref="files"
              class="form-control"
              multiple
              v-on:change="handleFilesUpload()"
              style="width: 300px"
            />
            <div v-if="files">
              <button @click="createUsers()" class="btn btn-success">
                Импортировать пользователей
              </button>
            </div>
          </label>

          <div class="progress">
            <div
              class="progress-bar"
              role="progressbar"
              :aria-valuenow="progress"
              v-bind:style="{ width: progress.toString() + '%' }"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              {{ Math.round(progress) }}%
            </div>
          </div>
          <br />

          <div class="table_view" id="printFile"></div>

          <!-- Отображение ошибок валидации -->
          <div v-if="validationErrors.length > 0" style="margin-top: 15px">
            <div
              style="
                color: #721c24;
                background-color: #f8d7da;
                padding: 10px;
                border-radius: 5px;
              "
            >
              <strong>Найдены ошибки в данных:</strong>
              <ul style="margin: 5px 0">
                <li v-for="(error, index) in validationErrors" :key="index">
                  {{ error }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import * as XLSX from "xlsx";
import TutorialDataService from "../services/TutorialDataService";

export default {
  name: "ImportUsersModal",
  props: {
    // Проп для вызова функции обновления списка пользователей
    onUsersImported: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      files: false,
      usersList: [],
      progress: 0,
      validationErrors: [],
      totalUsersToCreate: 0,
      successfulImports: 0,
      failedImports: 0,
    };
  },
  methods: {
    close() {
      this.resetComponent();
      this.$emit("close");
    },
    resetComponent() {
      this.files = [];
      this.usersList = [];
      this.progress = 0;
      this.validationErrors = [];
      this.totalUsersToCreate = 0;
      this.successfulImports = 0;
      this.failedImports = 0;
    },

    loadImportUsersTemplate() {
      TutorialDataService.loadImportUsersTemplate()
        .then((response) => {
          var blob = response.data;
          var contentType = response.data.type;
          var binaryData = [];
          binaryData.push(blob);

          if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              new Blob([binaryData], { type: contentType }),
              "import_users_template.xlsx",
            );
          } else {
            var link = document.createElement("a");
            document.body.appendChild(link);
            link.download = "import_users_template.xlsx";
            link.href = window.URL.createObjectURL(
              new Blob(binaryData, { type: contentType }),
            );
            link.click();
            document.body.removeChild(link);
          }
        })
        .catch((e) => {
          alert("Шаблон не найден", e);
        });
    },

    async createUsers() {
      // Валидация данных перед импортом
      this.validationErrors = this.validateUsersData();

      if (this.validationErrors.length > 0) {
        alert(
          "Обнаружены ошибки в данных. Пожалуйста, исправьте их перед импортом.",
        );
        return;
      }

      if (this.usersList.length === 0) {
        alert("Нет данных для импорта.");
        return;
      }

      alert(`Начинается импорт ${this.usersList.length} пользователей.`);
      this.progress = 10;
      this.totalUsersToCreate = this.usersList.length;
      this.successfulImports = 0;
      this.failedImports = 0;

      // Прогресс на пользователя
      let progressIncrement = (90 - 10) / this.totalUsersToCreate;

      for (let i = 0; i < this.usersList.length; i++) {
        const userData = this.usersList[i];

        try {
          await TutorialDataService.createUser(userData);
          this.successfulImports++;
          console.log(`Пользователь ${userData.username} успешно создан`);
        } catch (error) {
          this.failedImports++;
          console.error(
            `Ошибка при создании пользователя ${userData.username}:`,
            error,
          );
        }

        this.progress += progressIncrement;

        // Обновление прогресс-бара каждые 10 записей
        if (i % 10 === 0) {
          await new Promise((resolve) => setTimeout(resolve, 10)); // Небольшая пауза
        }
      }

      this.progress = 100;

      // Показать результат
      this.showImportResult();

      // Обновить список пользователей
      if (typeof this.onUsersImported === "function") {
        this.onUsersImported();
      }

      // Можно также эмиттить событие для родительского компонента
      this.$emit("users-imported", {
        total: this.totalUsersToCreate,
        success: this.successfulImports,
        failed: this.failedImports,
      });
    },

    validateUsersData() {
      const errors = [];
      const validRoles = [
        "teacher",
        "employee",
        "parent_comitet",
        "admin",
        "parent",
      ];

      this.usersList.forEach((user, index) => {
        const rowNumber = index + 2; // +2 потому что первая строка - заголовки

        if (!user.username || user.username.trim() === "") {
          errors.push(`Строка ${rowNumber}: Логин не может быть пустым`);
        }

        if (!user.password || user.password.trim() === "") {
          errors.push(`Строка ${rowNumber}: Пароль не может быть пустым`);
        }

        if (!user.role || !validRoles.includes(user.role)) {
          errors.push(
            `Строка ${rowNumber}: Некорректная роль. Допустимые значения: ${validRoles.join(
              ", ",
            )}`,
          );
        }

        // if (!user.photo || user.photo.trim() === "") {
        //   errors.push(
        //     `Строка ${rowNumber}: Ссылка на фото не может быть пустой`,
        //   );
        // }
      });

      return errors;
    },

    showImportResult() {
      const container = document.getElementById("printFile");
      const resultHtml = `
        <div style='text-align: center; padding: 15px;'>
          <div style='background-color: #d4edda; color: #155724; border: 1px solid #c3e6cb; border-radius: 5px; padding: 15px;'>
            <strong>Импорт завершен!</strong>
            <br>
            Всего обработано: ${this.totalUsersToCreate}
            <br>
            Успешно: ${this.successfulImports}
            <br>
            С ошибками: ${this.failedImports}
            ${
              this.failedImports > 0
                ? "<br><small>Проверьте консоль для деталей об ошибках</small>"
                : ""
            }
          </div>
        </div>
      `;
      container.innerHTML = resultHtml;
    },

    handleFilesUpload() {
      this.resetComponent();
      this.files = this.$refs.files.files[0];

      if (!this.files) return;

      const reader = new FileReader();

      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });

          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];

          // Отображение таблицы в превью
          const container = document.getElementById("printFile");
          container.innerHTML = XLSX.utils.sheet_to_html(worksheet);
          document
            .querySelector("#printFile table")
            .classList.add("table_view_students_import");

          // Конвертация в JSON
          const jsonData = XLSX.utils.sheet_to_json(worksheet);

          // Преобразование данных в нужный формат
          this.usersList = jsonData.map((row) => ({
            username: String(row.username || row.Логин || "").trim(),
            password: String(row.password || row.Пароль || "").trim(),
            role: String(row.role || row.Роль || "teacher")
              .trim()
              .toLowerCase(),
            photo: String(row.photo || row.Фото || "").trim(),
          }));

          console.log("Загруженные пользователи:", this.usersList);
        } catch (error) {
          console.error("Ошибка при чтении файла:", error);
          alert(
            "Ошибка при чтении файла. Убедитесь, что файл в правильном формате.",
          );
        }
      };

      reader.readAsArrayBuffer(this.files);
    },
  },
};
</script>

<style scoped>
/* Стили из вашего оригинального компонента */
.table_view {
  padding-bottom: 10px;
  padding-top: 10px;
  background: #ffffff;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  max-width: 700px;
  max-height: 240px;
  vertical-align: middle;
  position: relative;
  text-align: left;
  background: #fff;
}

label {
  display: flex;
  justify-content: space-between;
  padding: 5px;
  width: 100%;
}

.table_view_students_import th,
td {
  padding: 0px auto 0px auto;
  text-align: left;
}

.v-row-group__header td {
  background-color: #9370db;
  color: white;
}

.modal-fade-enter,
.modal-fade-leave-active {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.5s ease;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-import {
  background: #ffffff;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  width: 700px;
  height: 550px; /* Немного увеличена высота для отображения ошибок */
  vertical-align: middle;
  position: relative;
  text-align: left;
  background: #fff;
}

.modal-header,
.modal-footer {
  padding: 15px;
  display: flex;
}

.modal-header {
  border-bottom: 1px solid #eeeeee;
  color: #4aae9b;
  justify-content: space-between;
}

.modal-footer {
  border-top: 1px solid #eeeeee;
}

.modal-body {
  position: relative;
  padding: 20px 10px;
}

.btn-close {
  border: none;
  font-size: 20px;
  padding: 20px;
  cursor: pointer;
  font-weight: bold;
  color: #4aae9b;
  background: transparent;
}

.btn-green {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
  padding: 2px;
}

.btn {
  padding: 8px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.btn-success {
  background-color: #28a745;
  color: white;
}

.btn-link {
  background: none;
  border: none;
  color: #007bff;
  text-decoration: underline;
  cursor: pointer;
  font-size: 14px;
}

.progress {
  height: 20px;
  margin-top: 10px;
  background-color: #e9ecef;
  border-radius: 4px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  background-color: #007bff;
  transition: width 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 12px;
}

.form-control {
  padding: 8px;
  border: 1px solid #ced4da;
  border-radius: 4px;
}
</style>
